import type { BotanicalFamily } from "@/mocks/configuracoes";
import SettingsStatusBadge from "./SettingsStatusBadge";

interface FamilyTableProps {
  families: BotanicalFamily[];
}

export default function FamilyTable({ families }: FamilyTableProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-background-200">
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Família</th>
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Espécies cadastradas</th>
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Observações</th>
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Status</th>
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Ações</th>
          </tr>
        </thead>
        <tbody>
          {families.map((f) => (
            <tr key={f.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
              <td className="py-2.5 px-3 text-foreground-900 font-medium">{f.name}</td>
              <td className="py-2.5 px-3">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-primary-50 text-primary-700 text-xs font-semibold">
                  <i className="ri-plant-line text-xs" />{f.speciesCount}
                </span>
              </td>
              <td className="py-2.5 px-3 text-foreground-500 text-xs">{f.observations || "—"}</td>
              <td className="py-2.5 px-3"><SettingsStatusBadge status={f.status} /></td>
              <td className="py-2.5 px-3">
                <button className="w-8 h-8 rounded-lg hover:bg-background-100 flex items-center justify-center text-foreground-400 hover:text-primary-600 transition-colors" title="Editar">
                  <i className="ri-edit-line text-sm" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}